import { Outlet } from "react-router";
import circlesDouble from "../../assets/vertical-circles-double.svg";
import circlesSingle from "../../assets/vertical-circles-single.svg";

export const AuthLayout = () => {
  return (
    <div className="flex size-full items-stretch overflow-clip">
      <img
        src={circlesSingle}
        className="hidden max-w-xl min-w-0 object-cover object-right md:max-xl:block"
      />
      <img
        src={circlesDouble}
        className="hidden max-w-xl min-w-0 object-cover object-right xl:block"
      />
      <div className="mx-auto max-h-full max-w-100 flex-auto overflow-y-auto px-xl md:min-w-100 md:px-4xl">
        <Outlet />
      </div>
    </div>
  );
};
